import { z } from 'zod';
import { FlowProducedType } from '../../../flowRun/producedType.js';
import { BaseFlowBlockSchema, FlowBlockReturnTypeSchema } from '../block.js';
import { FlowBlockType } from '../type.js';
export const FlowGetExternalDocumentPacketBlockSchema = BaseFlowBlockSchema.extend({
    type: z.literal(FlowBlockType.GetExternalDocumentPacket),
    returnType: FlowBlockReturnTypeSchema(FlowProducedType.ExternalDocumentPacket),
    config: z.object({
        externalDocumentPacketId: z.string().optional(),
    }),
});
//# sourceMappingURL=config.js.map